// extracted by mini-css-extract-plugin
export default {"button":"NavigationButton_button__gg5vw"};